// extracted by mini-css-extract-plugin
export var player = "VideoPlayer-module--player--5f66b";
export var youtubePlayer = "VideoPlayer-module--youtubePlayer--a9b64";